__webpack_require__.p = "/holiday-edition-shifts-in-supply-or-demand/";